import React from 'react';
import SarasTrans from '../../../../library/notifications/SarasTrans';

const BudgetGridLocationBreakupH = () => (
    <div style={{width: 250, textAlign: 'left'}}>
        <span style={{display: 'inline-block', width: 70, verticalAlign: 'top', textAlign: 'center'}}><SarasTrans value="Sheet Qty" /></span>
        <span style={{display: 'inline-block', width: 80, verticalAlign: 'top', textAlign: 'left'}}><SarasTrans value="Location" /></span>
        <span style={{display: 'inline-block', width: 100, verticalAlign: 'top', textAlign: 'left'}}><SarasTrans value="Comment" /></span>
    </div>
);

export default BudgetGridLocationBreakupH;
